import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, CreditCard, FileText, Zap, Users, BookOpen } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-20 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden bg-brand-900 text-white" data-id="element-188">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffffff 1px, transparent 1px)',
      backgroundSize: '32px 32px'
    }} data-id="element-189"></div>

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-190">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-191">
          <span className="inline-block py-1 px-3 rounded-full bg-brand-800 border border-brand-700 text-brand-100 text-sm font-semibold tracking-wide mb-6" data-id="element-192">
            🇨🇷 RECONECTA CONTIGO HOY™
          </span>

          <h1 className="md:text-6xl font-extrabold mb-6 text-white text-[28px]" data-id="element-193">
            Todo tu año en el MEP. <br className="hidden md:block" data-id="element-194" />
            <span className="text-accent-400" data-id="element-195">Resuelto. Desde hoy.</span>
          </h1>

          <p className="text-xl md:text-2xl font-medium text-brand-100 mb-8 max-w-3xl mx-auto" data-id="element-196">
            El sistema N°1 para docentes del MEP en Costa Rica — Primaria y
            Secundaria — Todos los niveles
          </p>

          <p className="text-lg text-brand-200 mb-10 max-w-2xl mx-auto" data-id="element-197">
            Plantillas + protocolos + dinámicas listas para usar.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="flex flex-wrap justify-center gap-3 mb-10" data-id="element-198">
          {[{
          icon: FileText,
          text: '100% PDF'
        }, {
          icon: Zap,
          text: 'Acceso en 5 min'
        }, {
          icon: Users,
          text: 'Primaria y Secundaria'
        }, {
          icon: BookOpen,
          text: 'Todos los niveles'
        }].map((badge, i) => <div key={i} className="flex items-center gap-1.5 bg-brand-800/50 border border-brand-700/50 py-1.5 px-3 rounded-md text-sm font-medium text-brand-50" data-id="element-199">
              <badge.icon className="w-4 h-4 text-accent-400" data-id="element-200" />
              {badge.text}
            </div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="flex flex-col items-center" data-id="element-201">
          <a href="#planes" className="inline-flex items-center justify-center w-full sm:w-auto px-8 py-4 text-lg font-bold text-white bg-accent-500 hover:bg-accent-600 rounded-xl shadow-[0_0_40px_rgba(16,185,129,0.35)] transition-all hover:scale-105 active:scale-95 mb-6" data-id="element-202">
            → QUIERO MI MEGAPACK AHORA
          </a>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm text-brand-200" data-id="element-203">
            <div className="flex items-center gap-1.5" data-id="element-204">
              <ShieldCheck className="w-4 h-4" data-id="element-205" />
              <span data-id="element-206">Garantía 7 días</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-207">
              <Lock className="w-4 h-4" data-id="element-208" />
              <span data-id="element-209">Pago seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-210">
              <CreditCard className="w-4 h-4" data-id="element-211" />
              <span data-id="element-212">Tarjeta </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}